import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    width: '100%',
    paddingBottom: theme.spacing(4),
    [theme.breakpoints.up('mobile')]: {
      paddingBottom: 0,
    },
  },
  title: {
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('mobile')]: {
      marginBottom: theme.spacing(4),
      fontSize: 24,
    },
  },
  text: {
    lineHeight: '21px',
    color: '#263238',
    [theme.breakpoints.up('mobile')]: {
      fontSize: 16,
      color: theme.palette.colors.black,
      lineHeight: '24px',
    },
  },
  formGroup: {
    margin: [theme.spacing(2), 0, 5],
    [theme.breakpoints.up('mobile')]: {
      margin: [theme.spacing(4), 0, theme.spacing(1)],
    },
  },
  fieldGroup: {
    // [theme.breakpoints.up('mobile')]: {
    //   display: 'flex',
    // },
  },
  field: {
    width: '100%',
    marginBottom: 11,
    '& fieldset': {
      borderColor: theme.palette.colors.border,
    },
    '& label': {
      position: 'relative',
      transform: 'none',
      fontSize: 12,
      marginBottom: theme.spacing(1),
      color: '#90A4AE',
    },
    '& input': {
      height: '100%',
      padding: [0, 14],
    },
    // [theme.breakpoints.up('mobile')]: {
    //   marginBottom: theme.spacing(3),
    //   '&:first-child': {
    //     width: '50%',
    //     marginRight: theme.spacing(2),
    //   },
    //   '& + &': {
    //     width: '50%',
    //     marginLeft: theme.spacing(2),
    //   },
    // },
  },
  radioGroup: {
    margin: [20, 0, theme.spacing(2)],
    [theme.breakpoints.up('mobile')]: {
      margin: [theme.spacing(3), 0, theme.spacing(2)],
    },
  },
  radioGroupLabel: {
    marginBottom: theme.spacing(2),
  },
  radioButton: {
    padding: 10,
  },
  radioIcon: {
    borderRadius: '50%',
    width: 15,
    height: 15,
    backgroundColor: theme.palette.colors.white,
    border: [1, 'solid', '#B3B3B3'],
  },
  checkedIcon: {
    backgroundColor: theme.palette.colors.teal,
    border: 'none',
    '&:before': {
      display: 'block',
      width: 15,
      height: 15,
      backgroundImage: 'radial-gradient(#fff,#fff 32%,transparent 32%)',
      content: '""',
    },
  },
  button: {
    width: '100%',
    [theme.breakpoints.up('mobile')]: {
      width: 310,
    },
  },
  buttonIcon: {
    marginRight: theme.spacing(1),
  },
}));



// WEBPACK FOOTER //
// ./src/components/BuyerSettings/components/OptionalInfoForm/useStyles.js